webpackJsonp([35783957827783],{

/***/ 714:
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(27));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(69));
	var _assertThisInitialized = _interopDefault(__webpack_require__(714));
	var _inheritsLoose = _interopDefault(__webpack_require__(716));
	var _defineProperty = _interopDefault(__webpack_require__(715));
	var React = __webpack_require__(1);
	var invariant = _interopDefault(__webpack_require__(19));
	
	var INSTANCE_MAP = new Map();
	var OBSERVER_MAP = new Map();
	var ROOT_IDS = new Map();
	var consecutiveRootId = 0;
	/**
	 * Generate a unique ID for the root element
	 * @param root
	 */
	
	function getRootId(root) {
	  if (!root) return '';
	  if (ROOT_IDS.has(root)) return ROOT_IDS.get(root);
	  consecutiveRootId += 1;
	  ROOT_IDS.set(root, consecutiveRootId.toString());
	  return ROOT_IDS.get(root) + '_';
	}
	/**
	 * Monitor element, and trigger callback when element becomes inView
	 * @param element {HTMLElement}
	 * @param callback {Function} Called with inView
	 * @param options {Object} InterSection observer options
	 * @param options.threshold {Number} Number between 0 and 1, indicating how much of the element should be inView before triggering
	 * @param options.root {HTMLElement}
	 * @param options.rootMargin {String} The CSS margin to apply to the root element.
	 */
	
	
	function observe(element, callback, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  // IntersectionObserver needs a threshold to trigger, so set it to 0 if it's not defined.
	  // Modify the options object, since it's used in the onChange handler.
	  if (!options.threshold) options.threshold = 0;
	  var _options = options,
	      root = _options.root,
	      rootMargin = _options.rootMargin,
	      threshold = _options.threshold; // Validate that the element is not being used in another <Observer />
	
	  invariant(!INSTANCE_MAP.has(element), "react-intersection-observer: Trying to observe %s, but it's already being observed by another instance.\nMake sure the `ref` is only used by a single <Observer /> instance.\n\n%s", element);
	  if (!element) return; // Create a unique ID for this observer instance, based on the root, root margin and threshold.
	  // An observer with the same options can be reused, so lets use this fact
	
	  var observerId = getRootId(root) + (rootMargin ? threshold.toString() + "_" + rootMargin : threshold.toString());
	  var observerInstance = OBSERVER_MAP.get(observerId);
	
	  if (!observerInstance) {
	    observerInstance = new IntersectionObserver(onChange, options);
	    /* istanbul ignore else  */
	
	    if (observerId) OBSERVER_MAP.set(observerId, observerInstance);
	  }
	
	  var instance = {
	    callback: callback,
	    element: element,
	    inView: false,
	    observerId: observerId,
	    observer: observerInstance
	  };
	  INSTANCE_MAP.set(element, instance);
	  observerInstance.observe(element);
	  return instance;
	}
	/**
	 * Stop observing an element. If an element is removed from the DOM or otherwise destroyed,
	 * make sure to call this method.
	 * @param element {Element}
	 */
	
	function unobserve(element) {
	  if (!element) return;
	  var instance = INSTANCE_MAP.get(element);
	
	  if (instance) {
	    var _observerId = instance.observerId,
	        _observer = instance.observer;
	    var root = _observer.root;
	
	    _observer.unobserve(element); // Check if we are still observing any elements with the same threshold.
	
	
	    var itemsLeft = false; // Check if we still have observers configured with the same root.
	
	    var rootObserved = false;
	
	    if (_observerId) {
	      INSTANCE_MAP.forEach(function (item, key) {
	        if (item && key !== element) {
	          if (item.observerId === _observerId) itemsLeft = true;
	          if (item.observer.root === root) rootObserved = true;
	        }
	      });
	    }
	
	    if (!rootObserved && root) ROOT_IDS.delete(root);
	
	    if (_observer && !itemsLeft) {
	      // No more elements to observe for threshold, disconnect observer
	      _observer.disconnect();
	    } // Remove reference to element
	
	
	    INSTANCE_MAP.delete(element);
	  }
	}
	
	function onChange(changes) {
	  changes.forEach(function (intersection) {
	    var isIntersecting = intersection.isIntersecting,
	        intersectionRatio = intersection.intersectionRatio,
	        target = intersection.target;
	    var instance = INSTANCE_MAP.get(target); // Firefox can report a negative intersectionRatio when scrolling.
	
	    if (instance && intersectionRatio >= 0) {
	      var thresholds = instance.observer.thresholds; // If threshold is an array, check if any of them intersects. This just triggers the onChange event multiple times.
	
	      var _inView = thresholds.some(function (threshold) {
	        return instance.inView ? intersectionRatio > threshold : intersectionRatio >= threshold;
	      });
	
	      if (isIntersecting !== undefined) {
	        // If isIntersecting is defined, ensure that the element is actually intersecting.
	        // Otherwise it reports a threshold of 0
	        _inView = _inView && isIntersecting;
	      }
	
	      instance.inView = _inView;
	      instance.callback(_inView, intersection);
	    }
	  });
	}
	
	/**
	 * Monitors scroll, and triggers the children function with updated props
	 *
	 <InView>
	 {({inView, ref}) => (
	   <h1 ref={ref}>{`${inView}`}</h1>
	 )}
	 </InView>
	 */
	var InView =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InView, _React$Component);
	
	  function InView() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      inView: false,
	      entry: undefined
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "node", null);
	
	    _defineProperty(_assertThisInitialized(_this), "handleNode", function (node) {
	      if (_this.node) unobserve(_this.node);
	      _this.node = node ? node : null;
	
	      _this.observeNode();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleChange", function (inView, entry) {
	      _this.setState({
	        inView: inView,
	        entry: entry
	      });
	
	      if (_this.props.onChange) {
	        _this.props.onChange(inView, entry);
	      }
	    });
	
	    return _this;
	  }
	
	  var _proto = InView.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    /* istanbul ignore else  */
	    if (false) {
	      invariant(this.node, "react-intersection-observer: No DOM node found. Make sure you forward \"ref\" to the root DOM element you want to observe.");
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If a IntersectionObserver option changed, reinit the observer
	    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold) {
	      unobserve(this.node);
	      this.observeNode();
	    }
	
	    if (prevState.inView !== this.state.inView) {
	      if (this.state.inView && this.props.triggerOnce) {
	        unobserve(this.node);
	        this.node = null;
	      }
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this.node) {
	      unobserve(this.node);
	      this.node = null;
	    }
	  };
	
	  _proto.observeNode = function observeNode() {
	    if (!this.node) return;
	    var _this$props = this.props,
	        threshold = _this$props.threshold,
	        root = _this$props.root,
	        rootMargin = _this$props.rootMargin;
	    observe(this.node, this.handleChange, {
	      threshold: threshold,
	      root: root,
	      rootMargin: rootMargin
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props2 = this.props,
	        children = _this$props2.children,
	        as = _this$props2.as,
	        tag = _this$props2.tag,
	        triggerOnce = _this$props2.triggerOnce,
	        threshold = _this$props2.threshold,
	        root = _this$props2.root,
	        rootMargin = _this$props2.rootMargin,
	        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin"]);
	
	    var _this$state = this.state,
	        inView = _this$state.inView,
	        entry = _this$state.entry;
	
	    if (typeof children === 'function') {
	      // @ts-ignore doesn't properly detect the function here...
	      return children({
	        inView: inView,
	        entry: entry,
	        ref: this.handleNode
	      });
	    }
	
	    return React.createElement(as || tag || 'div', _extends({
	      ref: this.handleNode
	    }, props), children);
	  };
	
	  return InView;
	}(React.Component);
	
	_defineProperty(InView, "displayName", 'InView');
	
	_defineProperty(InView, "defaultProps", {
	  threshold: 0,
	  triggerOnce: false
	});
	
	function useInView(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _React$useState = React.useState(null),
	      ref = _React$useState[0],
	      setRef = _React$useState[1];
	
	  var _React$useState2 = React.useState({
	    inView: false,
	    entry: undefined
	  }),
	      state = _React$useState2[0],
	      setState = _React$useState2[1];
	
	  React.useEffect(function () {
	    if (ref) {
	      observe(ref, function (inView, intersection) {
	        setState({
	          inView: inView,
	          entry: intersection
	        });
	
	        if (inView && options.triggerOnce) {
	          // If it should only trigger once, unobserve the element after it's inView
	          unobserve(ref);
	        }
	      }, options);
	    }
	
	    return function () {
	      if (ref) unobserve(ref);
	    };
	  }, [// Only create a new Observer instance if the ref or any of the options have been changed.
	  ref, options.threshold, options.root, options.rootMargin, options.triggerOnce]);
	  React.useDebugValue(state.inView);
	  return [setRef, state.inView, state.entry];
	}
	
	exports.default = InView;
	exports.InView = InView;
	exports.useInView = useInView;


/***/ }),

/***/ 1274:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/character--keoni-bill@3x.e2e8d9f8.png";

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/house--background@3x.09df065b.png";

/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/house--characters@3x.e67636cd.png";

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--bath.5a8b38fc.png";

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--bed.79eb97f3.png";

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--city.66a826b0.png";

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--garage.0c84b007.png";

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--kitchen.eda43d38.png";

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--laundry.cf1b4511.png";

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/room--living.9d6132a9.png";

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var arrowChooser = function arrowChooser(_ref) {
	  var theme = _ref.theme,
	      position = _ref.position,
	      pointerPosition = _ref.pointerPosition;
	
	  switch (position) {
	    case 'right':
	      return '\n        border-right: ' + theme.spacing(1) + ' solid #fff;\n        right: 99%;\n        top: ' + pointerPosition + ';\n        transform: translateY(-50%);\n      ';
	    case 'left':
	      return '\n        border-left: ' + theme.spacing(1) + ' solid #fff;\n        left: 99%;\n        top: ' + pointerPosition + ';\n        transform: translateY(-50%);\n      ';
	    case 'top':
	      return '\n        border-top: ' + theme.spacing(1) + ' solid #fff;\n        top: 99%;\n        left: ' + pointerPosition + ';\n        transform: translateX(-50%);\n      ';
	    case 'bottom':
	      return '\n        border-bottom: ' + theme.spacing(1) + ' solid #fff;\n        bottom: 99%;\n        left: ' + pointerPosition + ';\n        transform: translateX(-50%);\n      ';
	  }
	};
	
	var animationChooser = function animationChooser(_ref2) {
	  var theme = _ref2.theme,
	      position = _ref2.position;
	
	  switch (position) {
	    case 'right':
	    case 'left':
	      return theme.animation.swingInHorizontal;
	    case 'top':
	    case 'bottom':
	      return theme.animation.swingInVertical;
	  }
	};
	
	var originChooser = function originChooser(_ref3) {
	  var theme = _ref3.theme,
	      position = _ref3.position;
	
	  switch (position) {
	    case 'right':
	      return 'left center';
	    case 'left':
	      return 'right center';
	    case 'top':
	      return 'center bottom';
	    case 'bottom':
	      return 'center top';
	  }
	};
	
	var PerspectiveContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'SpeechBubble__PerspectiveContainer'
	})(['perspective:1500px;width:', 'px;'], function (p) {
	  return p.theme.mediaSizes.medium * (p.wide ? 0.5 : 0.42);
	});
	
	var SpeechBubbleContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'SpeechBubble__SpeechBubbleContainer'
	})(['animation:', ';animation-delay:', 'ms;animation-duration:0.5s;animation-fill-mode:forwards;background-color:#fff;border-radius:', ';box-shadow:0 0.75rem 1.5rem rgba(0,0,0,0.25);color:#3b474c;opacity:0;padding:', ';position:relative;transform-origin:', ';width:100%;&::after{border:', ' solid transparent;content:\'\';display:', ';height:0;position:absolute;width:0;', ';}'], function (p) {
	  return p.showAnimation ? animationChooser(p) : 'none';
	}, function (p) {
	  return typeof p.animationDelay === 'undefined' ? 1000 : p.animationDelay;
	}, function (p) {
	  return p.theme.radius(0);
	}, function (p) {
	  return p.theme.spacing(1);
	}, originChooser, function (p) {
	  return p.theme.spacing(0);
	}, function (p) {
	  return p.showPointer ? 'block' : 'none';
	}, arrowChooser);
	
	var SpeechBubbleHeading = _styledComponents2.default.h3.withConfig({
	  displayName: 'SpeechBubble__SpeechBubbleHeading'
	})(['color:#eda44d;font-size:', ';line-height:1;margin-bottom:', ';text-transform:uppercase;'], function (p) {
	  return p.theme.fontSize(2.25);
	}, function (p) {
	  return p.theme.spacing(-1);
	});
	
	var SpeechBubbleContent = _styledComponents2.default.div.withConfig({
	  displayName: 'SpeechBubble__SpeechBubbleContent'
	})(['p{font-size:', ';line-height:1;margin-bottom:', ';&:last-child{margin-bottom:0;}}em{color:#059ca6;text-transform:uppercase;}'], function (p) {
	  return p.theme.fontSize(1.75);
	}, function (p) {
	  return p.theme.spacing(-1);
	});
	
	var SpeechBubble = function (_Component) {
	  _inherits(SpeechBubble, _Component);
	
	  function SpeechBubble() {
	    _classCallCheck(this, SpeechBubble);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SpeechBubble.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        heading = _props.heading,
	        showPointer = _props.showPointer,
	        props = _objectWithoutProperties(_props, ['className', 'children', 'heading', 'showPointer']);
	
	    return _react2.default.createElement(
	      PerspectiveContainer,
	      { className: className },
	      _react2.default.createElement(
	        SpeechBubbleContainer,
	        _extends({ showPointer: showPointer }, props),
	        heading && _react2.default.createElement(
	          SpeechBubbleHeading,
	          null,
	          heading
	        ),
	        children && _react2.default.createElement(
	          SpeechBubbleContent,
	          null,
	          children
	        )
	      )
	    );
	  };
	
	  return SpeechBubble;
	}(_react.Component);
	
	SpeechBubble.propTypes = {
	  animationDelay: _propTypes2.default.number,
	  heading: _propTypes2.default.string,
	  pointerPosition: _propTypes2.default.string,
	  position: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom']).isRequired,
	  showAnimation: _propTypes2.default.bool,
	  showPointer: _propTypes2.default.bool,
	  wide: _propTypes2.default.bool
	};
	SpeechBubble.defaultProps = {
	  animationDelay: 0,
	  pointerPosition: '50%',
	  showAnimation: true,
	  showPointer: true,
	  wide: false
	};
	exports.default = SpeechBubble;
	module.exports = exports['default'];

/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    padding: ', ' ', ';\n  '], ['\n    padding: ', ' ', ';\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    margin: -', ' -', ';\n  '], ['\n    margin: -', ' -', ';\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    padding-top: ', ';\n    padding-bottom: ', ';\n  '], ['\n    padding-top: ', ';\n    padding-bottom: ', ';\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    background: transparent;\n    font-size: ', ';\n    padding-bottom: ', ';\n    padding-top: 0;\n  '], ['\n    background: transparent;\n    font-size: ', ';\n    padding-bottom: ', ';\n    padding-top: 0;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    height: ', ';\n  '], ['\n    height: ', ';\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    margin-bottom: 0;\n    position: relative;\n  '], ['\n    margin-bottom: 0;\n    position: relative;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    flex-shrink: 0;\n    margin: -', ' 0 0 ', ';\n    max-width: none;\n    width: 30%;\n  '], ['\n    flex-shrink: 0;\n    margin: -', ' 0 0 ', ';\n    max-width: none;\n    width: 30%;\n  ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    display: block;\n  '], ['\n    display: block;\n  ']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n    right: -', ';\n    width: 60%;\n  '], ['\n    right: -', ';\n    width: 60%;\n  ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n    margin-bottom: 0;\n    padding-top: ', ';\n    position: relative;\n  '], ['\n    margin-bottom: 0;\n    padding-top: ', ';\n    position: relative;\n  ']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n    align-self: flex-end;\n    flex-shrink: 0;\n    margin: -', ' 0 0 ', ';\n    max-width: none;\n    width: 40%;\n  '], ['\n    align-self: flex-end;\n    flex-shrink: 0;\n    margin: -', ' 0 0 ', ';\n    max-width: none;\n    width: 40%;\n  ']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n    left: -', ';\n    width: 60%;\n  '], ['\n    left: -', ';\n    width: 60%;\n  ']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n    overflow: visible;\n  '], ['\n    overflow: visible;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactIntersectionObserver = __webpack_require__(1172);
	
	var _theme = __webpack_require__(4);
	
	var _Preload = __webpack_require__(88);
	
	var _Preload2 = _interopRequireDefault(_Preload);
	
	var _AspectRatio = __webpack_require__(420);
	
	var _AspectRatio2 = _interopRequireDefault(_AspectRatio);
	
	var _SpeechBubble = __webpack_require__(154);
	
	var _SpeechBubble2 = _interopRequireDefault(_SpeechBubble);
	
	var _textHomeEnergyTips = __webpack_require__(708);
	
	var _textHomeEnergyTips2 = _interopRequireDefault(_textHomeEnergyTips);
	
	var _characterPluggyForward3x = __webpack_require__(128);
	
	var _characterPluggyForward3x2 = _interopRequireDefault(_characterPluggyForward3x);
	
	var _characterKeoniBill3x = __webpack_require__(1274);
	
	var _characterKeoniBill3x2 = _interopRequireDefault(_characterKeoniBill3x);
	
	var _houseCharacters3x = __webpack_require__(1286);
	
	var _houseCharacters3x2 = _interopRequireDefault(_houseCharacters3x);
	
	var _houseBackground3x = __webpack_require__(1285);
	
	var _houseBackground3x2 = _interopRequireDefault(_houseBackground3x);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _roomBath = __webpack_require__(31);
	
	var _roomBath2 = _interopRequireDefault(_roomBath);
	
	var _roomBed = __webpack_require__(32);
	
	var _roomBed2 = _interopRequireDefault(_roomBed);
	
	var _roomGarage = __webpack_require__(34);
	
	var _roomGarage2 = _interopRequireDefault(_roomGarage);
	
	var _roomKitchen = __webpack_require__(35);
	
	var _roomKitchen2 = _interopRequireDefault(_roomKitchen);
	
	var _roomLaundry = __webpack_require__(36);
	
	var _roomLaundry2 = _interopRequireDefault(_roomLaundry);
	
	var _roomLiving = __webpack_require__(37);
	
	var _roomLiving2 = _interopRequireDefault(_roomLiving);
	
	var _roomCity = __webpack_require__(33);
	
	var _roomCity2 = _interopRequireDefault(_roomCity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Preload items
	
	
	var preloadItems = [_roomBath2.default, _roomBed2.default, _roomGarage2.default, _roomKitchen2.default, _roomLaundry2.default, _roomLiving2.default, _roomCity2.default];
	
	var CommonSpacing = _styledComponents2.default.div.withConfig({
	  displayName: 'pages__CommonSpacing'
	})(['padding:', ' ', ';', ';'], function (p) {
	  return p.theme.spacing(0);
	}, function (p) {
	  return p.theme.spacing(1);
	}, _theme.media.greaterThan('medium')(_templateObject, function (p) {
	  return p.theme.spacing(1);
	}, function (p) {
	  return p.theme.spacing(2);
	}));
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'pages__Container'
	})(['background:linear-gradient(to right,#155564,#274554);display:flex;flex-direction:column;max-width:50rem;width:calc(100% + 2 * ', ');margin:-', ';', ';'], function (p) {
	  return p.theme.spacing(1);
	}, function (p) {
	  return p.theme.spacing(1);
	}, _theme.media.greaterThan('medium')(_templateObject2, function (p) {
	  return p.theme.spacing(3);
	}, function (p) {
	  return p.theme.spacing(1);
	}));
	
	var HomeEnergyTips = (0, _styledComponents2.default)(CommonSpacing).withConfig({
	  displayName: 'pages__HomeEnergyTips'
	})(['', ';'], _theme.media.greaterThan('medium')(_templateObject3, function (p) {
	  return p.theme.spacing(2);
	}, function (p) {
	  return p.theme.spacing(1);
	}));
	
	var HomeEnergyTipsImage = _styledComponents2.default.img.withConfig({
	  displayName: 'pages__HomeEnergyTipsImage'
	})(['margin:0 auto;height:', ';'], function (p) {
	  return p.theme.spacing(4);
	});
	
	var LearnHowToReduce = (0, _styledComponents2.default)(CommonSpacing).withConfig({
	  displayName: 'pages__LearnHowToReduce'
	})(['background:linear-gradient(to right,#073342,#05161d);color:#c9e9ea;font-size:', ';padding-bottom:', ';text-align:center;text-transform:uppercase;', ';'], function (p) {
	  return p.theme.fontSize(1);
	}, function (p) {
	  return p.theme.spacing(1);
	}, _theme.media.greaterThan('medium')(_templateObject4, function (p) {
	  return p.theme.fontSize(1.5);
	}, function (p) {
	  return p.theme.spacing(2);
	}));
	
	var CharacterScene = (0, _styledComponents2.default)(CommonSpacing).withConfig({
	  displayName: 'pages__CharacterScene'
	})(['align-items:flex-start;display:flex;flex-direction:column;padding-bottom:0;padding-top:0;', ';'], _theme.media.greaterThan('medium')(_templateObject5, function (p) {
	  return p.theme.spacing(9);
	}));
	
	var CharacterScenePluggy = (0, _styledComponents2.default)(CharacterScene).withConfig({
	  displayName: 'pages__CharacterScenePluggy'
	})(['background:linear-gradient(215deg,#0a6b78,#b7d89c);margin-bottom:-', ';', ';'], function (p) {
	  return p.theme.spacing(1);
	}, _theme.media.greaterThan('medium')(_templateObject6));
	var CharacterScenePluggyImageAspectRatio = (0, _styledComponents2.default)(_AspectRatio2.default).withConfig({
	  displayName: 'pages__CharacterScenePluggyImageAspectRatio'
	})(['margin:-', ' auto -10vh;max-width:', ';transform:translateX(-9%);width:40%;', ';'], function (p) {
	  return p.theme.spacing(-1);
	}, function (p) {
	  return p.theme.spacing(7);
	}, _theme.media.greaterThan('medium')(_templateObject7, function (p) {
	  return p.theme.spacing(0);
	}, function (p) {
	  return p.theme.spacing(3);
	}));
	
	var CharacterScenePluggyImage = _styledComponents2.default.img.withConfig({
	  displayName: 'pages__CharacterScenePluggyImage'
	})(['width:100%;height:100%;']);
	
	var CharacterScenePluggySpeechBubbleMobile = (0, _styledComponents2.default)(_SpeechBubble2.default).withConfig({
	  displayName: 'pages__CharacterScenePluggySpeechBubbleMobile'
	})(['margin:0 auto;', ';'], _theme.media.greaterThan('medium')(_templateObject8));
	
	var CharacterScenePluggySpeechBubbleDesktop = (0, _styledComponents2.default)(_SpeechBubble2.default).withConfig({
	  displayName: 'pages__CharacterScenePluggySpeechBubbleDesktop'
	})(['display:none;margin:0;position:absolute;right:', ';top:50%;transform:translateY(-50%);width:50%;', ';', ';'], function (p) {
	  return p.theme.spacing(1);
	}, _theme.media.greaterThan('medium')(_templateObject9), _theme.media.greaterThan('large')(_templateObject10, function (p) {
	  return p.theme.spacing(2);
	}));
	
	var CharacterSceneKeoni = (0, _styledComponents2.default)(CharacterScene).withConfig({
	  displayName: 'pages__CharacterSceneKeoni'
	})(['background:linear-gradient(125deg,#d881b5,#086c7b);padding-top:', ';margin-bottom:-', ';', ';'], function (p) {
	  return p.theme.spacing(4);
	}, function (p) {
	  return p.theme.spacing(1);
	}, _theme.media.greaterThan('medium')(_templateObject11, function (p) {
	  return p.theme.spacing(3);
	}));
	
	var CharacterSceneKeoniImageAspectRatio = (0, _styledComponents2.default)(_AspectRatio2.default).withConfig({
	  displayName: 'pages__CharacterSceneKeoniImageAspectRatio'
	})(['margin:0 auto -5vh;transform:translateX(-4%);width:50%;', ';'], _theme.media.greaterThan('medium')(_templateObject12, function (p) {
	  return p.theme.spacing(4.5);
	}, function (p) {
	  return p.theme.spacing(3);
	}));
	
	var CharacterSceneKeoniImage = _styledComponents2.default.img.withConfig({
	  displayName: 'pages__CharacterSceneKeoniImage'
	})(['height:100%;width:100%;']);
	
	var CharacterSceneKeoniSpeechBubbleMobile = (0, _styledComponents2.default)(_SpeechBubble2.default).withConfig({
	  displayName: 'pages__CharacterSceneKeoniSpeechBubbleMobile'
	})(['position:relative;margin:0 auto;z-index:1;', ';'], _theme.media.greaterThan('medium')(_templateObject8));
	
	var CharacterSceneKeoniSpeechBubbleDesktop = (0, _styledComponents2.default)(_SpeechBubble2.default).withConfig({
	  displayName: 'pages__CharacterSceneKeoniSpeechBubbleDesktop'
	})(['display:none;margin:0;position:absolute;left:', ';top:50%;transform:translateY(-50%);width:50%;', ';', ';'], function (p) {
	  return p.theme.spacing(1);
	}, _theme.media.greaterThan('medium')(_templateObject9), _theme.media.greaterThan('large')(_templateObject13, function (p) {
	  return p.theme.spacing(2);
	}));
	
	var HouseScene = (0, _styledComponents2.default)(CommonSpacing).withConfig({
	  displayName: 'pages__HouseScene'
	})(['background:linear-gradient(to right,#155564,#274554);display:flex;flex-direction:column;position:relative;padding:0;overflow:hidden;', ';'], _theme.media.greaterThan('medium')(_templateObject14));
	
	var HouseSceneBackgroundImage = _styledComponents2.default.img.withConfig({
	  displayName: 'pages__HouseSceneBackgroundImage'
	})(['left:0;opacity:0.8;position:absolute;right:0;top:2%;width:100%;']);
	
	var HouseSceneImageAspectRatio = (0, _styledComponents2.default)(_AspectRatio2.default).withConfig({
	  displayName: 'pages__HouseSceneImageAspectRatio'
	})(['margin:-', ' -15% 0;max-width:none;position:relative;width:130%;'], function (p) {
	  return p.theme.spacing(2);
	});
	
	var HouseSceneImage = _styledComponents2.default.img.withConfig({
	  displayName: 'pages__HouseSceneImage'
	})(['height:100%;width:100%;']);
	
	var LetsHelpButton = (0, _styledComponents2.default)(_Button2.default).withConfig({
	  displayName: 'pages__LetsHelpButton'
	})(['align-self:center;margin:', ' 0;'], function (p) {
	  return p.theme.spacing(3);
	});
	
	var HouseSceneSpeechBubble = (0, _styledComponents2.default)(_SpeechBubble2.default).withConfig({
	  displayName: 'pages__HouseSceneSpeechBubble'
	})(['margin:0 auto;']);
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Preload2.default,
	      { items: preloadItems },
	      function () {
	        return _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            HomeEnergyTips,
	            null,
	            _react2.default.createElement(HomeEnergyTipsImage, { src: _textHomeEnergyTips2.default })
	          ),
	          _react2.default.createElement(
	            LearnHowToReduce,
	            null,
	            'Learn how energy efficiency can save you money while helping Hawaii reach its 100% clean energy goals!'
	          ),
	          _react2.default.createElement(
	            _reactIntersectionObserver.InView,
	            null,
	            function (_ref) {
	              var inView = _ref.inView,
	                  ref = _ref.ref;
	              return _react2.default.createElement(
	                CharacterScenePluggy,
	                { innerRef: ref },
	                _react2.default.createElement(
	                  CharacterScenePluggyImageAspectRatio,
	                  {
	                    width: 97.42,
	                    height: 187
	                  },
	                  _react2.default.createElement(CharacterScenePluggyImage, {
	                    src: _characterPluggyForward3x2.default
	                  })
	                ),
	                _react2.default.createElement(
	                  CharacterScenePluggySpeechBubbleDesktop,
	                  {
	                    heading: 'Aloha Energy Saver!',
	                    position: 'right',
	                    showAnimation: inView
	                  },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'I\'m Pluggy and I\'ll be your',
	                    ' ',
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'FRIENDLY HOME ENERGY ADVISOR.'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  CharacterScenePluggySpeechBubbleMobile,
	                  {
	                    heading: 'Aloha Energy Saver!',
	                    position: 'bottom',
	                    showAnimation: inView
	                  },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'I\'m Pluggy and I\'ll be your',
	                    ' ',
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'FRIENDLY HOME ENERGY ADVISOR.'
	                    )
	                  )
	                )
	              );
	            }
	          ),
	          _react2.default.createElement(
	            _reactIntersectionObserver.InView,
	            null,
	            function (_ref2) {
	              var inView = _ref2.inView,
	                  ref = _ref2.ref;
	              return _react2.default.createElement(
	                CharacterSceneKeoni,
	                { innerRef: ref },
	                _react2.default.createElement(
	                  CharacterSceneKeoniImageAspectRatio,
	                  { width: 483, height: 855 },
	                  _react2.default.createElement(CharacterSceneKeoniImage, { src: _characterKeoniBill3x2.default })
	                ),
	                _react2.default.createElement(
	                  CharacterSceneKeoniSpeechBubbleDesktop,
	                  {
	                    position: 'bottom',
	                    pointerPosition: '45%',
	                    showAnimation: inView
	                  },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'This is Keoni.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Let\'s help him identify ways to ',
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'save money'
	                    ),
	                    ' on his electric bill, while contributing to a ',
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'cleaner'
	                    ),
	                    ' ',
	                    'and more ',
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'resilient'
	                    ),
	                    ' future for Hawaii!'
	                  )
	                ),
	                _react2.default.createElement(
	                  CharacterSceneKeoniSpeechBubbleMobile,
	                  {
	                    position: 'bottom',
	                    showAnimation: inView,
	                    showPointer: false
	                  },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'This is Keoni.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Let\'s help him identify ways to ',
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'save money'
	                    ),
	                    ' on his electric bill, while contributing to a ',
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'cleaner'
	                    ),
	                    ' ',
	                    'and more ',
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'resilient'
	                    ),
	                    ' future for Hawaii!'
	                  )
	                )
	              );
	            }
	          ),
	          _react2.default.createElement(
	            _reactIntersectionObserver.InView,
	            null,
	            function (_ref3) {
	              var inView = _ref3.inView,
	                  ref = _ref3.ref;
	              return _react2.default.createElement(
	                HouseScene,
	                { innerRef: ref },
	                _react2.default.createElement(HouseSceneBackgroundImage, { src: _houseBackground3x2.default }),
	                _react2.default.createElement(
	                  HouseSceneImageAspectRatio,
	                  { width: 2182, height: 2073 },
	                  _react2.default.createElement(HouseSceneImage, { src: _houseCharacters3x2.default })
	                ),
	                _react2.default.createElement(
	                  HouseSceneSpeechBubble,
	                  {
	                    heading: 'Thanks for helping!',
	                    position: 'bottom',
	                    showAnimation: inView
	                  },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Let\'s head inside!'
	                  )
	                ),
	                _react2.default.createElement(
	                  LetsHelpButton,
	                  { to: '/age/', size: 'large' },
	                  'Let\'s Help'
	                )
	              );
	            }
	          )
	        );
	      }
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-5ac2f22f6f7accd99714.js